/**
 * Stable pin identifiers for sidebar pinning.
 *
 * Single source of truth for the id a pinned app/agent is stored under in
 * usePinnedItems, so the kebab menu (which toggles) and the sidebar (which
 * filters) can never derive different ids for the same row.
 *
 * Apps: cloud rows are keyed by instanceId; solo rows have no instanceId and
 * are keyed by appSlug — mirrors AppsPage's own routing/identity logic.
 * Agents: keyed by the immutable workflowType slug (survives renames).
 */
export const appPinId = (a) =>
  a?.deployMode === 'solo' ? `solo:${a.appSlug}` : a?.instanceId;

export const agentPinId = (p) => p?.workflowType;
